// 1. React and fabric. 
import * as React from 'react';

// https://infinum.com/the-capsized-eight/how-to-use-react-hooks-in-class-components
function useScreenSize(): any
{
	const [width , setWidth ] = React.useState(window.innerWidth );
	const [height, setHeight] = React.useState(window.innerHeight);

	React.useEffect(() =>
	{
		const handler = (event: any) =>
		{
			setWidth (event.target.innerWidth );
			setHeight(event.target.innerHeight);
		};
		window.addEventListener('resize', handler);
		return () =>
		{
			window.removeEventListener('resize', handler);
		};
	}, []);

	return {width, height};
}

const withScreenSizeHook = (Component: any) =>
{
	return (props: any) =>
	{
		const screenSize = useScreenSize();
		return <Component screenSize={ screenSize } {...props} />;
	};
};

export default withScreenSizeHook;
